import { render, staticRenderFns } from "./infomodal.vue?vue&type=template&id=03b91349&scoped=true"
import script from "./infomodal.vue?vue&type=script&lang=ts"
export * from "./infomodal.vue?vue&type=script&lang=ts"
import style0 from "./infomodal.vue?vue&type=style&index=0&id=03b91349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b91349",
  null
  
)

export default component.exports